import { render, staticRenderFns } from "./StockListC.vue?vue&type=template&id=65a387bc&"
import script from "./StockListC.vue?vue&type=script&lang=js&"
export * from "./StockListC.vue?vue&type=script&lang=js&"
import style0 from "./StockListC.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports